var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "css-grid sales-chart__container" },
    [
      _c("ChartMixVendor", {
        attrs: { "entity-data": _vm.entityData, filters: _vm.filters }
      }),
      _vm._v(" "),
      _c("ChartMixTier", {
        attrs: { "entity-data": _vm.entityData, filters: _vm.filters }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }